import styled from '@emotion/styled';

import { css } from 'config/emotionCss';

import colors from 'config/theme/colors';
import { MEDIA_TYPE } from 'constants/MediaConstants';
import { Button } from 'ui/base';

export const Content = styled('div', { target: 'fb-media-library-content' })`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${({ shortCard }) => (shortCard ? 150 : 232)}px, 1fr));
  gap: 12px;
  width: 100%;

  padding: 16px;
  background-color: ${colors['@body-bg']};
  border-radius: 8px;

  &.upload-modal {
    padding: 0;
    .media {
      &:hover,
      &.media-active {
        .thumbnail::after {
          position: absolute;
          content: '';
          top: 0;
          left: 0;
          right: 0;
          height: 40px;
          background: linear-gradient(0deg, rgba(66, 66, 66, 0) 0%, rgba(66, 66, 66, 0.4) 100%);
          z-index: 10;
        }
      }
    }
  }
`;

export const StarButton = styled(Button)`
  border: none;
  padding: 0;

  &:hover{
    border: unset !important;
  }

  &[disabled] {
    [class^='fb-icon'] {
      color: ${colors['@font-grey-light']} !important;
    }
  }

  [class^='fb-icon'] {
    color: #ffab00;
    font-size: 20px !important;
  }
`;

export const Title = styled.p`
  font-weight: 500;
  font-size: 18px;
`;

export const Details = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  color: ${colors['@font-grey-light']};
  span:nth-child(even) {
    font-weight: 500;
    color: ${colors['@text-color']};
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ButtonRight = styled.div`
  display: flex;
  gap: 12px;
`;

export const Media = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  height: 300px;
  border-radius: 12px;
  background-color: ${({ type }) => (type === MEDIA_TYPE.DOCUMENT ? colors['@body-bg'] : 'white')};
  }
`;

export const Image = styled.img`
  display: block;
  max-height: 300px;
  max-width: 100%;
  user-select: none;
  border-radius: 12px;
`;

export const Video = styled.video`
  height: 300px;
  aspect-ratio: 16/9;
  padding: 12px;
`;

export const SortPanel = styled.div`
  overflow: auto;
  height: 200px;
  margin-top: 5px;
`;

export const styledRadio = css`
  border-bottom: 1px solid ${colors['@border-light-grey']};
  padding: 12px 0;
  margin-left: 2px;

  &:last-child {
    border-bottom: none;
  }
`;
